import PropTypes from 'prop-types';
import { Colors } from '@spotahome/ui-library';

const theme = {
  base: Colors.primary,
  light: 'white',
  interaction: Colors.interaction,
  interactionDark: Colors['interaction-dark']
};

const ThreeSixty = ({ theme: themeKey = 'base' }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1267 3.87333C8.07203 3.37544 5.92813 3.37544 3.87341 3.87333C4.44508 1.575 5.63508 0 7.00008 0C8.36508 0 9.55508 1.575 10.1267 3.87333ZM3.5 7.00008C3.49852 5.94665 3.62386 4.89688 3.87333 3.87341C1.575 4.44508 0 5.63508 0 7.00008C0 8.36508 1.575 9.55508 3.87333 10.1267C3.62386 9.10328 3.49852 8.05351 3.5 7.00008ZM10.1266 3.87341C10.3761 4.89688 10.5014 5.94665 10.4999 7.00008C10.5014 8.05346 10.3761 9.1032 10.1266 10.1266C9.1032 10.3761 8.05346 10.5014 7.00008 10.4999C5.94665 10.5014 4.89688 10.3761 3.87341 10.1266C4.44508 12.4249 5.63508 13.9999 7.00008 13.9999C8.36505 13.9999 9.55504 12.425 10.1267 10.1267C12.425 9.55504 13.9999 8.36505 13.9999 7.00008C13.9999 5.63508 12.4249 4.44508 10.1266 3.87341ZM4.66667 7C4.66774 6.29151 4.73413 5.58463 4.865 4.88833C5.56908 4.75396 6.28333 4.67981 7 4.66667C7.716 4.67211 8.43025 4.73846 9.135 4.865C9.2673 5.56896 9.3337 6.28372 9.33333 7C9.33167 7.70793 9.26922 8.41442 9.14667 9.11167C7.72507 9.34501 6.27493 9.34501 4.85333 9.11167C4.73078 8.41442 4.66833 7.70793 4.66667 7Z"
      fill={theme[themeKey]}
    />
  </svg>
);

ThreeSixty.propTypes = {
  theme: PropTypes.oneOf(['base', 'light', 'interaction', 'interactionDark'])
};

export default ThreeSixty;
